var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowBottom = function SvgArrowBottom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.997 99.6031C279.785 86.5313 269.122 76 256 76C242.745 76 232 86.7452 232 100V354.059L128.971 251.029L128.679 250.743C119.285 241.658 104.305 241.753 95.0294 251.029C85.6569 260.402 85.6569 275.598 95.0294 284.971L239.029 428.971L239.321 429.257C248.715 438.342 263.695 438.247 272.971 428.971L416.971 284.971L417.257 284.679C426.342 275.285 426.247 260.305 416.971 251.029L416.679 250.743C407.285 241.658 392.305 241.753 383.029 251.029L280 354.059V100L279.997 99.6031Z",
    fill: "#222428"
  })));
};

export { SvgArrowBottom as ReactComponent };
export default __webpack_public_path__ + "static/media/images/arrowBottom.svg";